// extracted by mini-css-extract-plugin
module.exports = {"SqueezeColumns":"squeezeColumns_SqueezeColumns___SmNq"};